import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AdminActions, PaymentActions } from 'redux/actions';
import { Layout } from 'components';
import { Form, Select, Spin } from 'antd';
import { Container, H1, PrimaryButton, Section } from 'utils';
import { adminServices } from 'services';

const { Option } = Select;
const FormItem = Form.Item;

export class AdminReconnect extends Component {
  componentDidMount() {
    const { getAllProjects } = this.props;
    getAllProjects(100000, 1, 'accepted');
  }
  static propTypes = {
    projects: PropTypes.array.isRequired,
    getAllProjects: PropTypes.func.isRequired,
    setPriorityProjects: PropTypes.func.isRequired,
    linkExistingStripeAccount: PropTypes.func.isRequired,
    // loading: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      loading: false,
      selectedProject: 0,
      selectedOwnProject: 0,
      selectedGeneralProject: 0,
      newAccountProject: 0,
      userProjects: [],
      generalProjects: [],
    };
  }

  onFinish = (values) => {
    const { linkExistingStripeAccount } = this.props;
    const {
      selectedProject,
      newAccountProject,
    } = this.state;

    linkExistingStripeAccount(
      selectedProject,
      newAccountProject,
      false,
    );
  };

  setProject = (id) => {
    const projects = this.props.projects.projects;

    const selectedProject = projects.find((p) => p.id === id);
    if (!selectedProject) return;

    const userProjects = projects.filter((p) => 
      p.user_id === selectedProject.user_id && p.id !== id
    );
    const generalProjects = projects.filter((p) => 
      p.id !== id
    );
    
    this.setState({ 
      selectedProject: id,
      userProjects,
      generalProjects,
    });
  }

  setNewAccount = (id, general = true) => {
    const projects = this.props.projects.projects;

    const selectedProject = projects.find((p) => p.id === id);
    if (!selectedProject) return;

    if (general) {
      this.setState({
        selectedGeneralProject: id,
        selectedOwnProject: 0,
      });
    } else {
      this.setState({
        selectedGeneralProject: 0,
        selectedOwnProject: id,
      });
    }
    this.setState({ 
      newAccountProject: id,
    });
  }

  render() {
    const { loading, userProjects, generalProjects } = this.state;
    const projects = this.props.projects.projects;

    return (
      <Layout>
        <Container>
          <Section>
            <H1>Account neu verknüpfen</H1>
            <p>
              Den Stripe Account eines Projektes mit dem Account eines anderen Projektes ersetzen.<br />
              Feld 1: Projekt, dessen Account geändert werden soll.<br />
              Feld 2: Liste der Projekte des besitzers des ersten Projektes.<br />
              Feld 3: Alle aktiven Projekte.<br />
              Es kann immer nur entweder Feld 2 oder Feld 3 ausgewählt werden.
            </p>
            <Spin spinning={loading}>
              <Form onFinish={this.onFinish}>
                <FormItem
                  valuePropName="defaultValue"
                  name={'selectedProject'}
                  label="Select Project to change"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    defaultValue={this.state.selectedProject}
                    value={this.state.selectedProject}
                    onChange={(value) => {
                      this.setProject(value);
                    }}
                    filterOption={(input, option) =>
                      option?.children.includes(input)
                    }
                  >
                    <Option value={0}>No project</Option>
                    {projects &&
                      projects.map((project) => (
                        <Option
                          key={`${JSON.stringify(project)}-1`}
                          value={project.id}
                        >
                          {project.title}
                        </Option>
                      ))}
                  </Select>
                  {this.state.showError && !this.state.selectedProject && (
                    <span style={{ color: 'red' }}>
                      Please input your Project1!
                    </span>
                  )}
                </FormItem>
                <FormItem
                  valuePropName="defaultValue"
                  name={'selectedOwnProject'}
                  label="Select own Account to link"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    defaultValue={this.state.selectedOwnProject}
                    value={this.state.selectedOwnProject}
                    onChange={(value) => {
                      this.setNewAccount(value, false);
                    }}
                    filterOption={(input, option) =>
                      option?.children.includes(input)
                    }
                  >
                    <Option value={0}>No project</Option>
                    {userProjects &&
                      userProjects.map((project) => (
                        <Option
                          key={`${JSON.stringify(project)}-6`}
                          value={project.id}
                        >
                          {project.title}
                        </Option>
                      ))}
                  </Select>
                  {this.state.showError && !this.state.selectedOwnProject && !this.state.selectedGeneralProject && (
                    <span style={{ color: 'red' }}>
                      Please input your Project2!
                    </span>
                  )}
                </FormItem>

                <FormItem
                  valuePropName="defaultValue"
                  name={'selectedGeneralProject'}
                  label="Select general Account to link"
                >
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    defaultValue={this.state.selectedGeneralProject}
                    value={this.state.selectedGeneralProject}
                    onChange={(value) => {
                      this.setNewAccount(value, true);
                    }}
                    filterOption={(input, option) =>
                      option?.children.includes(input)
                    }
                  >
                    <Option value={0}>No project</Option>
                    {generalProjects &&
                      generalProjects.map((project) => (
                        <Option
                          key={`${JSON.stringify(project)}-6`}
                          value={project.id}
                        >
                          {project.title}
                        </Option>
                      ))}
                  </Select>
                  {this.state.showError && !this.state.selectedGeneralProject && !this.state.selectedOwnProject && (
                    <span style={{ color: 'red' }}>
                      Please input your Project2!
                    </span>
                  )}
                </FormItem>

                <FormItem valuePropName="defaultValue">
                  <PrimaryButton
                    type="primary"
                    htmltype="submit"
                    minWidth="100%"
                  >
                    Submit
                  </PrimaryButton>
                </FormItem>
              </Form>
            </Spin>
          </Section>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { projects, loading } = state.admin;
  return {
    projects,
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllProjects: (perPage, page, status) =>
    dispatch(AdminActions.getAllProjects(perPage, page, status)),
  setPriorityProjects: (projectsIdsArray) =>
    dispatch(AdminActions.setPriorityProjects(projectsIdsArray)),
  linkExistingStripeAccount: (projectId, accountId, user) =>
    dispatch(PaymentActions.linkExistingStripeAccount(projectId, accountId, user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AdminReconnect);
